<div class="main-filter-wrap" #filter>
  <div
    class="main-icon"
    [class.applied-filter]="isFilterApplied"
    [class.opened-filter]="showHideFilter"
  >
    <div (click)="showHideFilter = !showHideFilter" class="filter-left">
      <i class="icon-vector"></i>
      <span>Filters</span>
    </div>
    <div class="filter-right" *ngIf="isFilterApplied">
      <div class="count-filter">{{ count }}</div>
      <div class="clear-filter" (click)="clearFilters()">&times;</div>
    </div>
  </div>
  <div [ngClass]="showHideFilter ? 'pop-up-active' : 'pop-up'">
    <form [formGroup]="formFilter">
      <!--checkbox-->
      <div
        *ngFor="let filter of filters"
        [ngSwitch]="filterTypes[filter.name]"
        class="ng-for"
      >
        <div *ngSwitchCase="'checkbox'">
          <app-filter-multi-select
            [selectArr]="filter.data"
            [title]="filter.name"
            [formControlName]="filter.name"
            ngDefaultControl
          >
          </app-filter-multi-select>
        </div>

        <!--input-->
        <div *ngSwitchCase="'input'">
          <app-autocomplete-field
            [filterData]="filter.data"
            [title]="filter.name"
            [formControlName]="filter.name"
            ngDefaultControl
          >
          </app-autocomplete-field>
        </div>

        <!--date-->
        <div *ngSwitchCase="'date'" class="date">
          <div class="category" (click)="showHideFunc(filter.name)">
            <h3>
              {{ filter.name | camelCase }}
              <button
                class="button remove-filter"
                (click)="clearDate(filter.name)"
                *ngIf="formFilter.controls[filter.name]?.value"
              >
                1 &times;
              </button>
            </h3>
            <i
              class="icon-arrow"
              [ngClass]="{rotate: showHideFunc(filter.name)}"
            ></i>
          </div>
          <div
            [style.display]="showHideFunc(filter.name) ? 'block' : 'none'"
            class="date-div-wrap"
          >
            <div class="date-div">
              <app-datepicker
                [iconLeft]="true"
                [formControlName]="filter.name"
                ngDefaultControl
                [withoutX]="true"
              ></app-datepicker>
            </div>
          </div>
        </div>

        <!--double date-->
        <div *ngSwitchCase="'doubleDate'" class="double-date">
          <div
            class="category"
            [style.margin-bottom]="
              filter.name === 'promotionInThePeriod' &&
              !showHideObj.promotionInThePeriod
                ? '30px'
                : '0'
            "
            (click)="showHideFunc(filter.name)"
          >
            <h3
              [style.width]="
                filter.name === 'promotionInThePeriod' ? '160px' : '131px'
              "
            >
              {{ filter.name | camelCase }}
              <button
                class="button remove-filter"
                (click)="clearDates(filter.name)"
                *ngIf="
                  formFilter.controls[filter.name]?.value.start ||
                  formFilter.controls[filter.name]?.value.end
                "
              >
                {{ countDobleDateFilters(formFilter.get(filter.name)?.value) }}
                &times;
              </button>
            </h3>
            <i
              class="icon-arrow"
              [ngClass]="{rotate: showHideFunc(filter.name)}"
            ></i>
          </div>
          <div
            [class.last-div]="filter.name === 'promotionInThePeriod'"
            [style.display]="showHideFunc(filter.name) ? 'block' : 'none'"
            [formGroupName]="filter.name"
            class="double-date-div-wrap"
          >
            <div class="date-div">
              <p>start</p>
              <app-datepicker
                [iconLeft]="true"
                formControlName="start"
                ngDefaultControl
                [withoutX]="true"
              ></app-datepicker>
            </div>
            <div class="date-div">
              <p>end</p>
              <app-datepicker
                [iconLeft]="true"
                formControlName="end"
                ngDefaultControl
                [withoutX]="true"
              ></app-datepicker>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
